<template>
  <b-container >
    <Loading :active.sync="Loading"></Loading>
    <b-form @submit="onSubmit">
      <div class="contenedor">
        <TicketForm :ticketData="dataform"/>
      </div>
  
      <b-button  
        :disabled="errors.any() || !dataform.descripcion || !wait" 
        type="submit"
        variant="primary" 
        class="mb-5"
      >
      Enviar
      </b-button>
    </b-form>
  </b-container>
</template>

<script>
  import {mapActions,mapState} from 'vuex'
  import Vue from 'vue'
  import axios from 'axios'
  import Loading from 'vue-loading-overlay'
  import _ from 'lodash'

  import validateMixin from '@/mixins/validation' //para usar el mixin de vee-validate
  import TicketForm from '@/components/tickets/TicketFormNew'
  export default {
    components:{
      Loading,TicketForm
    }, 
    mixins : [validateMixin],
    data:function () {
      return{
        dataform: {
          titulo: '',
          descripcion:'',
          categoria:1,
          categorias:[],
          maquinas:[],
          maquina:null,
        },
        wait:true,
        
      }
    }, 
    mounted(){this.init()},
    computed:{
      //variable del state que tiene el id del login.
      ...mapState('login',['id']),
      //variable que almacenas las categorias del backend.
      ...mapState('etiquetas',['categorias','etiquetas']),

      ...mapState('ticket',['isOk']),
    },
    methods:{
      ...mapActions({
        _crear: 'ticket/crearTicket',
        _categorias: 'etiquetas/fetchCategorias',
        _etiquetas: 'etiquetas/buscarEtiquetas'
      }),
      init(){
        this._categorias().then(() => {
          let that = this//dentro del foreach no usar this.
            _.forEach(this.categorias, function(value,key){
              let payload = {
                  value: value.id,
                  text:  value.nombre
              }
              that.dataform.categorias.push(payload)
            })  //_.forEach  
        })//then
        let payload = {
          'id' : 3  // tres es el listado de maquinas
        }
        this._etiquetas(payload).then(()=>{
          let that = this
          _.forEach(this.etiquetas, function(value,key){
            let payload = {
              value: value.id,
              text: value.nombre
            }
            that.dataform.maquinas.push(payload)
          })//_.forEach
        })
      },//init
      async onSubmit(evt){
        evt.preventDefault()
        // esta variable previene que se envien varias solicitudes
        this.wait = false 
        
        const validate = await this.$validator.validateAll()
        /*
         *  Si encuentra un error en la validacion sale del metodo. 
         */
        if(!validate) {return false} 
        
          let payload = {
          'solicitante':  this.id, 
          'titulo' : this.dataform.titulo,
          'descripcion' : this.dataform.descripcion,
          'categoria' : this.dataform.categoria,
          'maquina' : this.dataform.maquina,
          }
      
        

        this._crear(payload).then(() =>{
           if(this.isOk){
		    			    this.$toasted.show('El ticket se guardo correctamente', { 
	 	    						theme: "bubble", 
	 	    						position: "top-right", 
	 	    						duration : 3000
                            })
                        this.onReset()
                        this.$router.go(0) 
                    }else{
                        this.$toasted.show('Error al guardar el ticket', { 
                  				duration : 3000
                          })
            }             
        })//_crear
      },//onSubmit
      
      /**reset
      *  metodo que limpia campos y errores.
      */
      onReset(){
        this.clearForm()
        this.clearErrors()
      },
      
      /* metodo que limpia los campos
       */
      clearForm(){
        Object.assign(this.$data, this.$options.data.apply(this))
      },

      /*
      * metodo que limpia los errores 
      */
      clearErrors(){
        this.wait = true
        this.$validator.reset()
      },
    },
  }
</script>

<style lang="scss" scoped>
.contenedor{
 
  margin-top: 1em;


}

</style>